import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Modal } from '../../../ui/modal/modal';
import { Button } from '../../../ui/button/button';
import './authModal.css';
import { Input } from '../../../ui/input/input';
import { useMask } from '@react-input/mask';
export var AuthModal = function (_a) {
    var onClose = _a.onClose, onSendCode = _a.onSendCode;
    var _b = useState(''), phone = _b[0], setPhone = _b[1];
    var _c = useState(false), isValid = _c[0], setIsValid = _c[1];
    var clearPhone = function (value) {
        var cleaned = parseInt(value.replace(/\D/g, '').replace(/^7/, ''));
        return cleaned;
    };
    var inputRef = useMask({
        mask: '+7(___)___-__-__',
        replacement: { _: /\d/ },
    });
    // Проверка валидности номера телефона
    useEffect(function () {
        // Проверяем, что номер полностью заполнен (должно быть 18 символов в формате +7 (9XX) XXX-XX-XX)
        // и первая цифра после скобки - 9 (это уже обеспечивается маской)
        setIsValid(phone.length === 16 && phone.indexOf('(9') > -1);
    }, [phone]);
    return (_jsx(Modal, { onClose: onClose, children: _jsxs("div", { className: 'auth-modal', children: [_jsxs("div", { className: 'auth-modal__title', children: ["\u0414\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430. ", _jsx("br", {}), " \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440:"] }), _jsx("div", { className: 'auth-modal__form', children: _jsx(Input, { variant: 'transparent', type: 'tel', placeholder: '\u0422\u0435\u043B\u0435\u0444\u043E\u043D', value: phone, onChange: function (e) { return setPhone(e.target.value); }, ref: inputRef }) }), _jsx(Button, { onClick: function () { return onSendCode(clearPhone(phone)); }, variant: 'primary', disabled: !isValid, children: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u0434" })] }) }));
};
